import { useQuery } from "react-query"
import { get_job_seeker_experiences } from "../../../services/approvals";


const useJobSeekerExperiences = (id) => {
    return useQuery('get_job_seeker_experiences', ()=> get_job_seeker_experiences(id))
}

export default useJobSeekerExperiences;